import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { UserService } from "app/shared/services/user.service";
import { CYD, Credential } from "../shared/models/credential";

@Component({
  selector: "app-graph",
  templateUrl: "./graph.component.html",
  styleUrls: ["./graph.component.css"],
})
export class GraphComponent implements OnInit, OnChanges {
  constructor(private userService: UserService) {}

  @Input() cyd: CYD;
  @Input() credential: Credential;

  personId: string;
  crcePercentage: number;
  crcePercentagePreviousYear: number;

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateCRCEProgressData();
  }

  private updateCRCEProgressData() {
    if (this.credential && this.credential.assessmentGroup) {
      if (this.credential.crceYear) {
        this.crcePercentage = Math.round(
          (this.credential.questionAnsweredCountForCurrentYearCRCE /
            this.credential.questionCountForCurrentYearCRCE) *
            100,
        );
      }
      if (this.credential.crcePreviousYear) {
        this.crcePercentagePreviousYear = Math.round(
          (this.credential.questionAnsweredCountForPreviousYearCRCE /
            this.credential.questionCountForPreviousYearCRCE) *
            100,
        );
      }
    }
  }

  barColorClass(pct: number): string {
    if (!pct || pct < 50) return "pct-danger";
    if (pct < 90) return "pct-warning";
    return "pct-success";
  }
}
